import Vue from "vue";
import VueI18n from "vue-i18n";
import VueRouter from "vue-router";
import ElementUI from "element-ui";
import Vuetify from "vuetify";
import locale from "element-ui/lib/locale/lang/en";
import BlockUIService from "./Shared/BlockUIService.js";
import App from "./App.vue";
import Layout from "./components/Layout/Layout.vue";
import Login from "./components/Login/Login.vue";
import Offices from "./components/Offices/Offices.vue";
import Chats from "./components/Chats/Chats.vue";
import Home from "./components/Home/Home.vue";
import DataService from "./Shared/DataService";
import Profile from "./components/Users/EditUsersProfile/EditUsersProfile.vue";
import Users from "./components/Users/Users.vue";
import ChangePassword from "./components/ChangePassword/ChangePassword.vue";
import VueEllipseProgress from "vue-ellipse-progress";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
Vue.use(VueEllipseProgress);

Vue.use(Vuetify);
Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(ElementUI, { locale });

Vue.component("vue-phone-number-input", VuePhoneNumberInput);

Vue.config.productionTip = false;

Vue.prototype.$http = DataService;
Vue.prototype.$blockUI = BlockUIService;

export const eventBus = new Vue();

//const i18n = new VueI18n({
//    locale: 'ar', // set locale
//    messages, // set locale messages
//})

const router = new VueRouter({
  mode: "history",
  base: __dirname,
  linkActiveClass: "active",
  routes: [
    {
      path: "/Login",
      component: Login,
    },
    {
      path: "/",
      component: App,
      children: [
        {
          path: "",
          component: Layout,
          children: [
            { path: "", component: Home },
            { path: "Profile", component: Profile },
              { path: "ChangePassword", component: ChangePassword },
              { path: "/Offices", component: Offices },
              { path: "/Users", component: Users },
              { path: "Chats", component: Chats },
          
          ],
        },
      ],
    },
    /*{ path: '/', component: Layout },*/
    //{ path: '/Municipalities', component: Municipalities },
    //{ path: '/Offices', component: Offices }
  ],
});

Vue.filter("toUpperCase", function (value) {
  if (!value) return "";
  return value.toUpperCase();
});

new Vue({
  router,
  render: (h) => {
    return h(App);
  },
}).$mount("#cpanel-management");
